import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { CONVENIENCE_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/ConvenienceDoors/ConvenienceDoorsColumnsInfo'
import { buildTargetExportModal } from './TargetExportModal'

const convenienceColumnHelper = createExportColumnHelper({
  columns: CONVENIENCE_DOORS_COLUMNS,
})

export default buildTargetExportModal({
  targetType: 'cstore',
  isDoors: true,
  title: 'Select Columns for Convenience Store Doors Download',
  subTitle:
    'Download up to 10,000 convenience store doors at a time, with any of the following columns. Any filters already applied will remain active.',
  submitText: 'Export Convenience Store Doors',
  progressName: 'Exporting Convenience Store Doors...',
  downloadLabel: 'Convenience Companies',
  useColumnGroups: () => [
    {
      title: 'Target Attributes',
      elements: [
        convenienceColumnHelper.retrieveColumn('name'),
        convenienceColumnHelper.retrieveColumn('chain_id'),
        convenienceColumnHelper.retrieveColumn('address'),
        convenienceColumnHelper.retrieveColumn('city'),
        convenienceColumnHelper.retrieveColumn('state'),
        convenienceColumnHelper.retrieveColumn('country'),
        convenienceColumnHelper.retrieveColumn('phone'),
        convenienceColumnHelper.retrieveColumn('website'),
        convenienceColumnHelper.retrieveColumn('reviews_avg'),
        convenienceColumnHelper.retrieveColumn('reviews_cnt'),
        convenienceColumnHelper.retrieveColumn('open_hours'),
        convenienceColumnHelper.retrieveColumn('chain_doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ],
})
